import React from 'react'
import { array, object } from 'prop-types'
import { withContext } from '../../../utils/withContext'
import { postRequest } from '../../../webapp/helpers/requestActions'
import CountrySelectInput from '../../../webapp/components/CountrySelectInput/CountrySelectInput'
import { validateEmail } from '../../helpers/validations'
import { Success } from '../../components/Messages'

import styles from './RegistryPage.styl'

class RegistryPage extends React.Component {

	static propTypes = {
		context: object,
		match: object
	}

	constructor(props) {
		super(props)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.state = {
			athlete: {
				name: '', email: '', password: '', passwordRep: '', goal: '', street: '', postalCode: '', city: '', country: '', biometricData: {}
			},
			date: new Date(),
			error: {},
			message: false
		}
	}

	handleErrorValidation(item, error) {
		for (const [key, value] of Object.entries(item)) {
			if (typeof value === 'object') {
				this.handleErrorValidation(value, error)
			}
			if (!value) {
				error[key] = true
			}
		}
	}
	handleSubmit(e) {
		e.preventDefault()
		const { athlete, error, date, tos } = this.state
		if (!tos) {
			this.setState({ error: { tos: true } })
			return
		}

		if (!validateEmail(athlete.email)) {
			this.setState({ error: { email: 'Emain por inserir' } })
			return
		}
		const validationErrors = {}
		this.handleErrorValidation(athlete, validationErrors)

		if (!athlete.name) {
			this.setState({ error: { name: 'Nome incompleto' } })
			return
		}

		if (!athlete.weight) {
			this.setState({ error: { weight: 'Inserir peso' } })
			return
		}

		if (athlete.password !== athlete.passwordRep || !athlete.password || !athlete.passwordRep) {
			this.setState({ error: { password: 'Passwords não identicas!' } })
			return
		}
		if (!athlete.goal) {
			this.setState({ error: { goal: true } })
			return
		}

		const submitData = {
			...athlete,
			biometricData: {
				...athlete.biometricData,
				birthday: date.getTime()
			},
			passwordRep: undefined
		}

		postRequest('/api/athletes/new_athlete', submitData)
			.then((res) => {
				if (res.error) {
					if (!res.error.type) {
						return
					}
					this.setState(prevState => ({ error: { ...prevState.error, [res.error.type]: res.error.name } }), this.scrollToElement('#start'))
					return
				}
				this.setState({ message: true })
				setTimeout(() => {
					window.location = '/login'
				}, 1500)
			})
			.catch(err => {
				console.log(err)
				this.setState({ error: true })
				setTimeout(() => { this.setState({ error: false }) }, 1500)
			})
	}
	scrollToElement(hash) {
		window.document.querySelector(hash).scrollIntoView({ behavior: 'smooth', block: 'start' })
	}
	computeErrors(error) {
		console.log(error)
		const errorList = Object.values(error)
			.filter(r => r)
			.map((errorMsg, i) => (
				<li key={ i }>
					<p>{ errorMsg }</p>
				</li>
			))
		if (!errorList.length) { return null }
		return (
			<div className={ styles['error-container'] }>
				<h2>Alguma coisa não está certa! :/</h2>
				<ul className={ styles['error-list'] }>
					{ errorList }
				</ul>
			</div>
		)
	}
	handleDateChange(e) {
		const date = new Date(this.state.date.getTime())
		const newMonth = e.target.value - 1
		const monthDays = this.getMonthDays(newMonth.toString())
		if (date.getDate() > monthDays) { date.setDate(monthDays) }
		date.setMonth(newMonth)
		this.setState({ date })
	}

	getMonthDays(month, year) {
		if (month.match(/^0|2|4|6|7|9|11/)) { return 31 } else if (month.match(/3|5|8|10/)) { return 30 } else if (year % 4 !== 0) { return 28 } else if (year % 100 !== 0 || year % 400 === 0) { return 29 } else { return 28 }
	}

	render() {
		const { athlete, error, message, date, tos } = this.state
		const { context: { i18n } } = this.props
		const computedErrors = this.computeErrors(error)
		const days = new Array(this.getMonthDays(date.getMonth().toString())).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const month = new Array(12).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const years = new Array(new Date().getFullYear() - 1920).fill().map((v, i) => <option key={ i } value={ new Date().getFullYear() - i }>{ new Date().getFullYear() - i }</option>)
		return (
			<section className={ styles.section }>
				{ message ? <Success /> : null }
				<div className={ styles['title-container'] }>
					<div className={ styles.titleDiv }>
						<div className={ styles.titles }>
							<h2>{ i18n`registry_title_label` }</h2>
						</div>
					</div>
				</div>
				<div id="start" className={ styles['content'] }>
					<form className={ styles.form } onSubmit={ this.handleSubmit }>
						{ computedErrors }
						<h2>{ i18n`registry_personal_info_label` }</h2>
						<label className={ `${ styles.inputBox } ${ error.name ? styles.error : null }` }>
							<label>{ i18n`name_label` }</label>
							<input type="text" name="name" placeholder="Indica o teu nome" value={ athlete.name || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, name: e.target.value } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.date ? styles.error : null }` }>
							<label>{ i18n`registry_birthday_label` }</label>
							<div className={ styles['date-selector'] }>
								<select value={ this.state.date.getDate() } onChange={ (e) => this.setState({ date: new Date(date.setDate(e.target.value)) }) }>
									{ days }
								</select>
								<select value={ this.state.date.getMonth() + 1 } onChange={ this.handleDateChange.bind(this) }>
									{ month }
								</select>
								<select value={ this.state.date.getFullYear() } onChange={ (e) => this.setState({ date: new Date(date.setFullYear(e.target.value)) }) }>
									{ years }
								</select>
							</div>
						</label>
						<label className={ `${ styles.inputBox } ${ error.phone ? styles.error : null }` }>
							<label>{ i18n`registry_phone_label` }</label>
							<input type="text" name="phone" placeholder="Introduzir numero de telemóvel" value={ athlete.phone || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, phone: e.target.value } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.nif ? styles.error : null }` }>
							<label>{ i18n`registry_nif_label` }</label>
							<input type="text" name="taxpayerNumber" placeholder="Introduzir NIF" value={ athlete.taxpayerNumber || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, taxpayerNumber: e.target.value } }) } } required />
						</label>

						<h2>{ i18n`registry_credentials_label` }</h2>
						<label className={ `${ styles.inputBox } ${ error.email ? styles.error : null }` }>
							<label>{ i18n`email_label` }</label>
							<input type="text" name="email" placeholder="Indica o teu email" value={ athlete.email || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, email: e.target.value } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.password ? styles.error : null }` }>
							<label>{ i18n`registry_password_label` }</label>
							<input type="password" name="password" placeholder="Indica a tua password" value={ athlete.password || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, password: e.target.value } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.password ? styles.error : null }` }>
							<label>{ i18n`registry_repeat_password_label` }</label>
							<input type="password" name="passwordRep" placeholder="Repete a tua password" value={ athlete.passwordRep || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, passwordRep: e.target.value } }) } } required />
						</label>

						<h2>{ i18n`registry_biometric_data_label` }</h2>
						<label className={ `${ styles.inputBox } ${ error.height ? styles.error : null }` }>
							<label>{ i18n`registry_height_label` }</label>
							<input type="text" placeholder="Introduzir altura" value={ athlete.biometricData.height || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, biometricData: { ...athlete.biometricData, height: e.target.value } } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.weight ? styles.error : null }` }>
							<label>{ i18n`registry_weigth_label` }</label>
							<input type="text" placeholder="Introduzir peso" value={ athlete.weight || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, weight: e.target.value } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.restBPM ? styles.error : null }` }>
							<label>{ i18n`registry_max_fc_label` }</label>
							<input type="text" placeholder="Introduzir frequência cardíaca máxima registada" value={ athlete.biometricData.rMaxBPM || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, biometricData: { ...athlete.biometricData, rMaxBPM: e.target.value } } }) } } required />
						</label>
						<label className={ `${ styles.inputBox } ${ error.rMaxBPM ? styles.error : null }` }>
							<label>{ i18n`registry_rest_fc_label` }</label>
							<input type="text" placeholder="Introduzir frequência cardíaca de repouso" value={ athlete.biometricData.restBPM || '' } onChange={ (e) => { this.setState({ athlete: { ...athlete, biometricData: { ...athlete.biometricData, restBPM: e.target.value } } }) } } required />
						</label>


						<h2>{ i18n`registry_personal_goals_info_label` }</h2>
						<label className={ styles.inputBox }>
							<label className={ `${ error.password ? styles.error : null }` }>{ i18n`registry_personal_goals_description_info_label` }</label>
							<input className={ `${ error.goal ? styles.error : null }` } type="text" name="goal" placeholder="Detalha melhor o teu objetivo" onChange={ (e) => { this.setState({ athlete: { ...athlete, goal: e.target.value } }) } } value={ athlete.goal || '' } required />
						</label>

						<h2>{ i18n`registry_address_label` }</h2>
						<label className={ styles.inputBox }>
							<label>{ i18n`registry_address_label` }</label>
							<input type="text" name="address" placeholder="Introduz a tua morada" onChange={ (e) => { this.setState({ athlete: { ...athlete, street: e.target.value } }) } } value={ athlete.street || '' } required />
						</label>
						<label className={ styles.inputBox }>
							<label>{ i18n`registry_postal_code_label` }</label>
							<input className={ `${ error.postalCode ? styles.error : null }` } type="text" name="postalCode" placeholder="Introduz o teu código postal" onChange={ (e) => { this.setState({ athlete: { ...athlete, postalCode: e.target.value } }) } } value={ athlete.postalCode || '' } required />
						</label>
						<label className={ styles.inputBox }>
							<label>{ i18n`registry_city_label` }</label>
							<input type="text" name="city" placeholder="Introduz a tua cidade" onChange={ (e) => { this.setState({ athlete: { ...athlete, city: e.target.value } }) } } value={ athlete.city || '' } required />
						</label>
						<div className={ styles.inputBox }>
							<label>{ i18n`registry_country_label` }</label>
							<CountrySelectInput
								className={ styles['country-select-input'] }
								onChange={ (e) => { this.setState({ athlete: { ...athlete, country: e.target.value } }) } }
								value={ athlete.country || '' }
							/>
						</div>
						<div className={ styles['tos-container'] }>
							<div>
								<p>{ i18n`agreement_label` } <a href="/tos" target="_blank">{ i18n`tos_label` }</a></p>
								<input type="checkbox" value={ tos } onChange={ () => { this.setState((prevState) => ({ tos: !prevState.tos })) } } required />
							</div>
							{ error.tos ? <small>{ i18n`agree_warning_label` }</small> : null }
						</div>
						<input className={ styles.submitButton } type="submit" value={ i18n`registry_send_label` } />
					</form>
				</div>
			</section >
		)
	}
}

export default withContext(RegistryPage)



// WEBPACK FOOTER //
// ./src/client/website/pages/RegistryPage/RegistryPage.js